import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'placeholder', label: 'Placeholder', kind: 'text' },
  { key: 'rows', label: 'Rows', kind: 'integer' },
  { key: 'cols', label: 'Cols', kind: 'integer' },
  { key: 'min_length', label: 'Min length', kind: 'integer' },
  { key: 'max_length', label: 'Max length', kind: 'integer' },
  { key: 'disallow_empty_spaces', label: 'Disallow empty spaces', kind: 'boolean' },
  { key: 'disallow_only_empty_spaces', label: 'Disallow only empty spaces', kind: 'boolean' },
  { key: 'rich_text', label: 'Rich text editor', kind: 'boolean' },
];

export default function TextareaConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
